import { generateInitialNotes } from "../data/init";
import { notesStore, notesQuery } from "./store";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/analytics";
import { authStore } from "./authStore";
import { EntityActions, resetStores } from "@datorama/akita";
import { Observable, OperatorFunction, merge, fromEvent, Subject } from "rxjs";
import { buffer, debounceTime, mergeAll, tap } from "rxjs/operators";
import * as R from "ramda";

import pJson from "../../../package.json";
import { Note, Schedule } from "../data";
import { addHours, startOfDay, startOfMonth, startOfWeek } from "date-fns";

const firebaseConfig = {
  apiKey: "AIzaSyDH4Po9LbQGfAyAeybKjuhM3BVTDmkYHJo",
  authDomain: "todoyogi-6aceb.firebaseapp.com",
  projectId: "todoyogi-6aceb",
  storageBucket: "todoyogi-6aceb.appspot.com",
  messagingSenderId: "711129205777",
  appId: "1:711129205777:web:f84ca4776bf934b4eb35b0",
  measurementId: "G-VX51E3GK9B",
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
firebase.analytics();

export const googleProvider = new firebase.auth.GoogleAuthProvider();
// googleProvider.addScope("https://www.googleapis.com/auth/calendar.readonly");

export const createAnonymousAccount = () => {
  firebase.auth().signInAnonymously();
};

export const linkToGoogle = () => {
  firebase
    .auth()
    .currentUser!.linkWithPopup(googleProvider)
    .then(function (result) {
      // Accounts successfully linked.
      var credential = result.credential;
      var user = result.user;
      console.log("successful link", credential, user);
      authStore.update({
        uid: user?.uid,
        displayName: user!.email,
      });
      // ...
    })
    .catch(function (error) {
      // Handle Errors here.
      // ...
      console.log("error", error);
      switch (error.code) {
        case "auth/credential-already-in-use":
          alert(
            "This account already exists, log out first and sign into it. "
          );
          break;

        default:
          alert(error.message);
          break;
      }
    });
  // var credential = firebase.auth.GoogleAuthProvider.credential(
  //   googleUser.getAuthResponse().id_token
  // );
};

export const createEmailAccount = (email, pwd) => {
  firebase
    .auth()
    .createUserWithEmailAndPassword(email, pwd)
    .then((userCredential) => {
      // Signed in
      var user = userCredential.user;
      // ...
    })
    .catch((error) => {
      alert(error);
      // ..
    });
};
export const loginToEmailAccount = (email, pwd, onFailure) => {
  firebase
    .auth()
    .signInWithEmailAndPassword(email, pwd)
    .then((userCredential) => {
      // Signed in
      var user = userCredential.user;
      // ...
    })
    .catch((error) => {
      if (onFailure) {
        onFailure(error);
      }
      // ..
    });
};

export const loginToGoogle = () => {
  firebase
    .auth()
    .signInWithPopup(googleProvider)
    .catch((error) => {
      alert("Couldn't login: " + error.message);
    })
    .then((res) => {
      console.log("login to google follow-up", res);
      const creds = (res as firebase.auth.UserCredential).credential;
      console.log("creds", creds);
      authStore.update({ creds });
    });
};

const ogout$ = new Subject();

export const logout = () => {
  ogout$.next(true);
  firebase.auth().signOut();
};

const deleteMany = (ids: string[]) => {
  const batch = db.batch();
  ids.forEach((id) => {
    batch.delete(
      db
        .collection(`users`)
        .doc(firebase.auth().currentUser?.uid)
        .collection("notes")
        .doc(id)
    );
  });
  batch.commit();
};

const convertDate = (firebaseObject: any) => {
  if (!firebaseObject) return null;

  for (const [key, value] of Object.entries(firebaseObject)) {
    // covert items inside array
    if (value && Array.isArray(value))
      firebaseObject[key] = value.map((item) => convertDate(item));

    // convert inner objects
    if (value && typeof value === "object") {
      firebaseObject[key] = convertDate(value);
    }

    // convert simple properties
    if (
      value &&
      typeof value === "object" &&
      value.hasOwnProperty("seconds") &&
      value.hasOwnProperty("nanoseconds") // This is brittle af, already broke w/ seconds only
    ) {
      firebaseObject[key] = (value as firebase.firestore.Timestamp).toDate();
    }
  }
  return firebaseObject;
};

// Fetches

const fetchListOrders = () => {
  firebase
    .firestore()
    .collection("users")
    .doc(firebase.auth().currentUser?.uid)
    .get()
    .then((userData) => {
      console.log("fetched listOrders");
      notesStore.update((state) => ({
        ...state,
        listOrders: userData.data()!.listOrders ?? {},
      }));
      syncOrders();
    })
    .catch((error) => {
      console.warn("couldn't fetch list orders");
    });
};

const scheduleCorrecter = (s: Schedule) => {
  if (s.type === "DAY") {
    return { ...s, day: startOfDay(addHours(s.day, 3)) };
  }
  if (s.type === "WEEK") {
    return {
      ...s,
      week: startOfWeek(addHours(s.week, 3), { weekStartsOn: 1 }),
    };
  }
  if (s.type === "MONTH") {
    return { ...s, month: startOfMonth(addHours(s.month, 3)) };
  }
  return s;
};

const correcter = (n: Note) => {
  return {
    ...n,
    schedule: scheduleCorrecter(n.schedule),
  };
};

const fetchNotes = () => {
  firebase
    .firestore()
    .collection("users")
    .doc(firebase.auth().currentUser?.uid)
    .collection("notes")
    .get()
    .then((notes) => {
      //@ts-ignore
      notesStore.set(
        notes.docs.map((n) => convertDate(n.data())).map(correcter)
      );
      syncNotes();
    })
    .catch((error) => {
      alert("Error: couldn't fetch notes");
    });
};

const fetchData = () => {
  fetchListOrders();
  fetchNotes();
};

// Piping for read, bootstrap of store with remote data

let firstChange = true;

firebase.auth().onAuthStateChanged((user) => {
  console.log("Auth state change", user);
  authStore.setLoading(false);

  if (user !== null) {
    authStore.update({
      uid: user?.uid,
      displayName: user.email,
    });
    fetchData();
    persistSignin();
  } else if (!firstChange) {
    resetStores();
    authStore.update({
      uid: undefined,
      displayName: undefined,
    });
    authStore.setLoading(false);
  }
  firstChange = false;
});

const authChanged$ = new Observable<firebase.User | null>((sub) =>
  firebase.auth().onAuthStateChanged((user) => sub.next(user))
);

// Piping for write: react to store change and persist

type BufferDebounce = <T>(debounce: number) => OperatorFunction<T, T[]>;
const bufferDebounce: BufferDebounce = (debounce) => (source) =>
  new Observable((observer) =>
    source
      .pipe(
        buffer(
          merge(
            source.pipe(debounceTime(debounce)),
            ogout$,
            fromEvent(window, "beforeunload")
          )
        )
      )
      .subscribe({
        next(x) {
          observer.next(x);
        },
        error(err) {
          observer.error(err);
        },
        complete() {
          observer.complete();
        },
      })
  );

const syncNotes = R.once(() => {
  notesQuery
    .selectEntityAction([
      EntityActions.Add,
      EntityActions.Set,
      EntityActions.Update,
    ])
    .pipe(bufferDebounce(5000))
    .subscribe((actions) => {
      console.log("saving changes");
      const changedIds = R.uniq(actions.flatMap((a) => a.ids));
      persistMany(changedIds);
    });
  notesQuery
    .selectEntityAction([EntityActions.Remove])
    .pipe(bufferDebounce(5000))
    .subscribe((actions) => {
      console.log("saving deletions");
      const deletedIds = R.uniq(actions.flatMap((a) => a.ids));
      console.log("dele", deletedIds);
      deleteMany(deletedIds);
    });
});

const syncOrders = R.once(() => {
  notesQuery
    .select((state) => state.listOrders)
    .pipe(bufferDebounce(5000))
    .subscribe((ords) => {
      if (R.sum(ords.map((o) => Object.keys(o).length)) > 0) {
        persistOrders();
      }
    });
});

// Effectors, functions tied to firebase.

const clientMetas = {
  modified: firebase.firestore.FieldValue.serverTimestamp(),
  clientVersion: pJson.version,
};

// const persistAllNotes = () => {
//   const batch = db.batch();
//   notesQuery.getAll().forEach((n) => {
//     batch.set(
//       db
//         .collection(`users`)
//         .doc(firebase.auth().currentUser?.uid)
//         .collection("notes")
//         .doc(n.id),
//       {
//         ...n,
//         ...clientMetas,
//       }
//     );
//   });
//   return batch.commit();
// };

const persistMany = (ids: string[]) => {
  const batch = db.batch();
  ids.forEach((id) => {
    const n = notesQuery.getEntity(id);
    if (n !== undefined) {
      batch.set(
        db
          .collection(`users`)
          .doc(firebase.auth().currentUser?.uid)
          .collection("notes")
          .doc(id),
        {
          ...n,
          ...clientMetas,
        }
      );
    }
  });
  return batch.commit().catch((error) => {
    alert("Couldn't save notes to the server");
  });
};

const persistSignin = () => {
  return db
    .collection(`users`)
    .doc(firebase.auth().currentUser?.uid)
    .set(
      {
        ...clientMetas,
      },
      { merge: true }
    );
};

const persistOrders = () => {
  console.log("persisting orders");
  return db.collection(`users`).doc(firebase.auth().currentUser?.uid).set(
    {
      listOrders: notesQuery.getValue().listOrders,
    },
    { merge: true }
  );
};
